import {z as zod} from "zod";

export type OttopilotAnalyticsWorkspaceCapabilityConfiguration = Record<string, never>;

export const ottopilotAnalyticsWorkspaceCapabilityConfigurationValidator: zod.ZodType<OttopilotAnalyticsWorkspaceCapabilityConfiguration> = zod.strictObject({});
